export const T = {
  en: {
    welcome_title:"StyleVote",welcome_sub:"Fashion Research Platform by Jolrasi",
    welcome_desc:"Complete a short qualification quiz first. Score 80% or higher to register and vote.",
    take_quiz:"Take Qualification Quiz →",already_registered:"Already registered?",login:"Login",
    question:"Question",of:"of",correct_so_far:"correct so far",next:"Next →",see_results:"See Results →",
    not_qualified:"Not Qualified",fail_msg:"You scored below 80%. You are not eligible to access this platform.",
    try_again:"Try Again",back_home:"← Back to Home",
    qualified:"✓ Qualified!",create_account:"Create Account",fill_details:"Fill in your details below",
    male:"♂ Male",female:"♀ Female",full_name:"Full Name",whatsapp:"WhatsApp Number",
    address:"Address",email:"Email Address",password:"Password",
    name_ph:"Your full name",wa_ph:"+880 1X XX XXX XXX",addr_ph:"City, Area",email_ph:"you@email.com",pass_ph:"Minimum 6 characters",
    creating:"Creating account...",create_btn:"Create Account →",have_account:"Already have an account? Login",
    fill_all:"Please fill in all fields.",pass_short:"Password must be at least 6 characters.",
    invalid_email:"Please enter a valid email address.",email_exists:"Email already registered. Please login.",reg_failed:"Registration failed. Check your connection.",
    welcome_back:"Welcome Back",login_sub:"Login to your account",logging_in:"Logging in...",login_btn:"Login →",
    no_account:"No account found with this email.",wrong_pass:"Incorrect password.",login_failed:"Login failed. Check your connection.",
    step_label:(n)=>`Step ${n}`,
    vote_instruction_title:"What to do in this step:",
    vote_instruction:"Look at the designs below. Select the one you like most, then rate it and choose your preferences. If none appeal to you, click 'None of these'.",
    select_instruction:"👆 Select the design you like most from the options below",
    rating_instruction:"⭐ Give a score out of 100 — how much do you like this design?",
    fabric_instruction:"🧵 Which fabric would you prefer for this design?",
    sleeve_instruction:"👕 Which sleeve style do you prefer?",
    bottom_instruction:"👖 Which bottom style do you prefer?",
    color_instruction:"🎨 Which color do you prefer?",
    none_option:"None of these designs appeal to me",
    submit_vote:(n)=>`Submit Step ${n} ✓`,update_vote:(n)=>`Update Step ${n} ✓`,
    saving:"Saving...",vote_saved:(n)=>`✓ Step ${n} completed!`,
    select_first:"Please select a design first.",save_failed:"Failed to save. Try again.",
    logout:"Logout",welcome_user:(name)=>`Welcome, ${name}!`,voted_badge:"✓ Completed",
    closed_title:"Platform Closed",closed_msg:"This platform is currently closed. Please check back later.",
    admin_login:"Admin Login",loading:"Loading...",
    wa_join_short:"WhatsApp Group",
  },
  bn: {
    welcome_title:"স্টাইলভোট",welcome_sub:"জলরাসি ফ্যাশন রিসার্চ প্ল্যাটফর্ম",
    welcome_desc:"প্রথমে একটি ছোট যোগ্যতা পরীক্ষা দিন। ৮০% বা তার বেশি স্কোর করলে রেজিস্ট্রেশন করতে পারবেন।",
    take_quiz:"যোগ্যতা পরীক্ষা দিন →",already_registered:"ইতিমধ্যে রেজিস্টার্ড?",login:"লগইন",
    question:"প্রশ্ন",of:"এর মধ্যে",correct_so_far:"টি সঠিক",next:"পরবর্তী →",see_results:"ফলাফল দেখুন →",
    not_qualified:"যোগ্য নন",fail_msg:"আপনি ৮০% এর নিচে স্কোর করেছেন। আপনি এই প্ল্যাটফর্মে প্রবেশ করতে পারবেন না।",
    try_again:"আবার চেষ্টা করুন",back_home:"← হোমে ফিরুন",
    qualified:"✓ যোগ্য!",create_account:"অ্যাকাউন্ট তৈরি করুন",fill_details:"নিচে আপনার তথ্য দিন",
    male:"♂ পুরুষ",female:"♀ মহিলা",full_name:"পুরো নাম",whatsapp:"হোয়াটসঅ্যাপ নম্বর",
    address:"ঠিকানা",email:"ইমেইল",password:"পাসওয়ার্ড",
    name_ph:"আপনার পুরো নাম",wa_ph:"+৮৮০ ১X XX XXX XXX",addr_ph:"শহর, এলাকা",email_ph:"আপনার@ইমেইল.com",pass_ph:"সর্বনিম্ন ৬ অক্ষর",
    creating:"অ্যাকাউন্ট তৈরি হচ্ছে...",create_btn:"অ্যাকাউন্ট তৈরি করুন →",have_account:"ইতিমধ্যে অ্যাকাউন্ট আছে? লগইন করুন",
    fill_all:"সব ঘর পূরণ করুন।",pass_short:"পাসওয়ার্ড কমপক্ষে ৬ অক্ষরের হতে হবে।",
    invalid_email:"সঠিক ইমেইল দিন।",email_exists:"এই ইমেইল ইতিমধ্যে রেজিস্টার্ড। লগইন করুন।",reg_failed:"রেজিস্ট্রেশন ব্যর্থ। ইন্টারনেট চেক করুন।",
    welcome_back:"স্বাগতম",login_sub:"আপনার অ্যাকাউন্টে লগইন করুন",logging_in:"লগইন হচ্ছে...",login_btn:"লগইন →",
    no_account:"এই ইমেইলে কোনো অ্যাকাউন্ট নেই।",wrong_pass:"ভুল পাসওয়ার্ড।",login_failed:"লগইন ব্যর্থ। ইন্টারনেট চেক করুন।",
    step_label:(n)=>`ধাপ ${n}`,
    vote_instruction_title:"এই ধাপে যা করতে হবে:",
    vote_instruction:"নিচের ডিজাইনগুলো দেখুন। যেটি সবচেয়ে পছন্দ সেটি বেছে নিন, তারপর আপনার মতামত ও পছন্দগুলো জানান। কোনোটি পছন্দ না হলে 'এগুলোর কোনোটিই না' ক্লিক করুন।",
    select_instruction:"👆 নিচের ডিজাইনগুলো থেকে সবচেয়ে পছন্দের ডিজাইনটি বেছে নিন",
    rating_instruction:"⭐ ১০০ এর মধ্যে নম্বর দিন — এই ডিজাইনটি আপনার কতটা পছন্দ?",
    fabric_instruction:"🧵 এই ডিজাইনের জন্য কোন কাপড় পছন্দ?",
    sleeve_instruction:"👕 কোন ধরনের হাতা পছন্দ?",
    bottom_instruction:"👖 কোন ধরনের পায়জামা/প্যান্ট পছন্দ?",
    color_instruction:"🎨 কোন রং পছন্দ?",
    none_option:"এগুলোর কোনো ডিজাইনই আমার পছন্দ না",
    submit_vote:(n)=>`ধাপ ${n} সম্পন্ন করুন ✓`,update_vote:(n)=>`ধাপ ${n} আপডেট করুন ✓`,
    saving:"সেভ হচ্ছে...",vote_saved:(n)=>`✓ ধাপ ${n} সম্পন্ন হয়েছে!`,
    select_first:"আগে একটি ডিজাইন বেছে নিন।",save_failed:"সেভ ব্যর্থ। আবার চেষ্টা করুন।",
    logout:"লগআউট",welcome_user:(name)=>`স্বাগতম, ${name}!`,voted_badge:"✓ সম্পন্ন হয়েছে",
    closed_title:"প্ল্যাটফর্ম বন্ধ",closed_msg:"এই প্ল্যাটফর্মটি এখন বন্ধ আছে। পরে আবার আসুন।",
    admin_login:"অ্যাডমিন লগইন",loading:"লোড হচ্ছে...",
    wa_join_short:"হোয়াটসঅ্যাপ গ্রুপ",
  },
};
